import PropTypes from 'prop-types';
import {useProductOptions} from '@shopify/hydrogen';

import {Sezzle} from '../global/sezzle.client';
import {YotpoStars} from '../yotpo/YotpoStars.client';
import {ProductImageSelector} from '.';
/**
 * ProductDescription component
 * Displays product wysiwyg content
 * Uses context from ProductOptionsProvider parent component to track selected variant
 */

export function ProductDescription({sanityProduct}) {
  // The useProductOptions hook returns an object that enables you to keep track of the selected variant
  const {selectedVariant} = useProductOptions();

  return (
    <>
      <div className="product-detail__sku">SKU: {selectedVariant?.sku}</div>
      <h1 className="product-detail__title">{sanityProduct?.store?.title}</h1>

      <div className="product-detail__images mobile">
        <ProductImageSelector sanityProduct={sanityProduct} />
      </div>
      <div className="product-detail__price">
        {selectedVariant?.priceV2?.amount && (
          <span className="product-detail__price--current">
            {moneyFormatter.format(selectedVariant?.priceV2?.amount)}
          </span>
        )}
        {selectedVariant?.compareAtPriceV2 &&
          selectedVariant?.priceV2?.amount !==
            selectedVariant?.compareAtPriceV2?.amount && (
            <span className="product-detail__price--compare-at">
              {moneyFormatter.format(selectedVariant?.compareAtPriceV2?.amount)}
            </span>
          )}
      </div>
      <Sezzle />
      <div className="product-detail__yotpo_stars">
        <YotpoStars sanityProduct={sanityProduct.store} />
      </div>
    </>
  );
}

const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

ProductDescription.propTypes = {
  sanityProduct: PropTypes.object.isRequired,
};
